import { Alert, Button, Flex, Typography } from 'antd';
import PropTypes from 'prop-types';

const StoreAliasHealthAlerts = ({ aliasHealth, onManage }) => {
  const unmatchedNames = aliasHealth.unmatchedNames || [];
  const duplicateNames = aliasHealth.duplicateNames || [];

  if (unmatchedNames.length === 0 && duplicateNames.length === 0) {
    return null;
  }

  return (
    <Flex vertical gap="middle">
      {duplicateNames.length > 0 ? (
        <Alert
          showIcon
          type="error"
          title="门店名称或别名存在重复"
          description={
            <Flex vertical gap={4}>
              {duplicateNames.map((duplicate) => (
                <Typography.Text key={duplicate.name}>
                  “{duplicate.name}”同时属于：
                  {duplicate.stores.map((store) => `${store.code} ${store.name}`).join('、')}
                </Typography.Text>
              ))}
              <Typography.Text>
                别名冲突请删除错误别名；标准名称冲突请回飞书门店主数据修正。
              </Typography.Text>
            </Flex>
          }
        />
      ) : null}
      {unmatchedNames.length > 0 ? (
        <Alert
          showIcon
          type="warning"
          title="经营事件中存在未归属的门店名称"
          description={`共 ${unmatchedNames.length} 个名称未归属。`}
          action={<Button onClick={onManage}>管理未归属名称</Button>}
        />
      ) : null}
    </Flex>
  );
};

const storeShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

StoreAliasHealthAlerts.propTypes = {
  aliasHealth: PropTypes.shape({
    duplicateNames: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        stores: PropTypes.arrayOf(storeShape).isRequired,
      }),
    ),
    unmatchedNames: PropTypes.arrayOf(
      PropTypes.shape({
        domains: PropTypes.arrayOf(PropTypes.string).isRequired,
        name: PropTypes.string.isRequired,
      }),
    ),
  }),
  onManage: PropTypes.func,
};

StoreAliasHealthAlerts.defaultProps = {
  aliasHealth: {
    duplicateNames: [],
    unmatchedNames: [],
  },
  onManage: undefined,
};

export default StoreAliasHealthAlerts;
